import JsonApiResource from './JsonApiResource'
import AnearApp from './AnearApp'
import AnearVenue from './AnearVenue'

export default class AnearZone extends JsonApiResource {

  constructor(json_data, json_included) {
    super(json_data, json_included)
    const includedApp = this.findIncluded(this.relationships['app'])
    const includedVenue = this.relationships?.venue ? this.findIncluded(this.relationships.venue) : undefined
    this.app = includedApp ? new AnearApp(includedApp, this.included) : undefined
    this.venue = includedVenue ? new AnearVenue(includedVenue, this.included) : undefined
  }

  get maxParticipantRadius() {
    return this.attributes['max-participation-radius']
  }

  get canPlayAgain() {
    return this.app.canPlayAgain
  }
}
